module.exports = function (f) {
  var html = "\n    <div class=\"units hide-scrollbar\">\n      <div class=\"units-title\"></div>\n      <div class=\"units-table\"></div>\n    </div>\n  ";
  return html;
};